//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 29/01/2025
// Version       : 1
// Description   : Dialog para colocar el kilometraje actual del vehículo antes de realizar su revisión
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import { useState } from "react";
import { DialogContent, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";

function KilometrajeTareasRevision({
  onConfirm,
  onClose,
  onClose2,
  kilometrajeInicial,
  kilometrajeUltimaRevision,
}) {
  const [kilometraje, setKilometraje] = useState(kilometrajeInicial || "");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const input = e.target.value;
    // Permitir solo números positivos con un máximo de 6 dígitos
    if (/^\d{0,6}$/.test(input)) {
      setKilometraje(input);
      setError(false); // Resetear error al cambiar el valor
      setErrorMessage("");
    }
  };

  const handleConfirm = () => {
    // Eliminar ceros a la izquierda y convertir a número entero
    const kilometrajeNormalizado = parseInt(kilometraje, 10) || 0; // Si no es un número válido, se establece en 0
    const kilometrajeInicialNum = parseInt(kilometrajeInicial, 10) || 0;
    const kilometrajeUltimaRevisionNum =
      parseInt(kilometrajeUltimaRevision, 10) || 0;

    if (kilometraje === "" || isNaN(kilometrajeNormalizado)) {
      // Verificar si el campo está vacío o no es un número válido
      setError(true);
      setErrorMessage("El kilometraje no puede estar vacío."); // Mostrar error si el campo está vacío
    } else if (kilometrajeNormalizado < 0) {
      // Verificar si el valor ingresado es negativo
      setError(true);
      setErrorMessage("El kilometraje no puede ser negativo."); // Mostrar error si el valor es menor a 0
    } else if (kilometrajeNormalizado < kilometrajeInicialNum) {
      // Verificar si el valor ingresado es menor al kilometraje inicial
      setError(true);
      setErrorMessage(
        `El kilometraje debe ser mayor o igual al inicial (${kilometrajeInicialNum} km).` // Mostrar error si no cumple
      );
    } else if (
      kilometrajeUltimaRevision &&
      kilometrajeNormalizado < kilometrajeUltimaRevisionNum
    ) {
      // Verificar si hay un kilometraje de última revisión y el valor ingresado es menor que este
      setError(true);
      setErrorMessage(
        `El kilometraje debe ser mayor o igual al de la última revisión (${kilometrajeUltimaRevisionNum} km).` // Mostrar error si no cumple
      );
    } else {
      // Si todas las validaciones pasan, usar el valor normalizado
      onConfirm(kilometrajeNormalizado); // Enviar el valor normalizado
      onClose(); // Cierra solo el diálogo hijo al confirmar
    }
  };

  const handleCancelar = () => {
    onClose2(); // Cierra tanto el diálogo hijo como el diálogo padre al cancelar
  };

  return (
  <>
    <DialogContent sx={{ px: 3, pb: 2 }}>
      <Grid container mt={1} mb={2.5}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            label="Kilometraje del Vehículo"
            placeholder="Inserte el kilometraje actual"
            required
            focused
            autoComplete="off"
            value={kilometraje}
            onChange={handleChange}
            error={error}
            helperText={
              error
                ? errorMessage
                : kilometrajeUltimaRevision
                ? `Kilometraje anterior: ${kilometrajeUltimaRevision} km`
                : ""
            }
            FormHelperTextProps={{
              sx: {
                color: error ? "red" : "gray",
                fontStyle: error ? "normal" : "italic",
                textAlign: "left",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">km</InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            }}
          />
        </Grid>
      </Grid>

      <Grid
        container
        justifyContent="space-between"
        spacing={2}
      >
        <Grid item xs={6}>
          <Button
            onClick={handleCancelar}
            color="error"
            variant="contained"
            fullWidth
            sx={{
              borderRadius: "8px",
              fontWeight: "bold",
            }}
          >
            VOLVER
          </Button>
        </Grid>

        <Grid item xs={6}>
          <Button
            onClick={handleConfirm}
            variant="contained"
            fullWidth
            sx={{
              borderRadius: "8px",
              fontWeight: "bold",
            }}
          >
            CONTINUAR
          </Button>
        </Grid>
      </Grid>
    </DialogContent>
  </>
);

}

export default KilometrajeTareasRevision;
